import React from 'react';
import { cn } from '../../utils/cn';

/**
 * Reusable Select component
 *
 * @param {Object} props
 * @param {Array} props.options - Select options [{value, label}]
 * @param {string} props.className - Additional CSS classes
 * @param {string} props.error - Error message
 */
export const Select = React.forwardRef(({ className, error, options, ...props }, ref) => {
  return (
    <select
      ref={ref}
      className={cn(
        'w-full px-4 py-3 border rounded-lg transition-all',
        'focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent',
        'disabled:bg-gray-100 disabled:cursor-not-allowed',
        error ? 'border-red-500' : 'border-gray-300',
        className
      )}
      {...props}
    >
      {options?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
});

Select.displayName = 'Select';
